import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { RtComponentOutlet } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  IconButtonComponent,
  IconComponent,
  NestedTemplateTriggerDirective,
} from '@core/user-interface-legacy';
import { DataSourceMoreSettingsCmp } from '@core/views-util';

import { ViewsAnalytics } from '../../../analytics/views-analytics';

@Component({
  selector: 'view-settings-more',
  imports: [
    DropdownHeaderComponent,
    IconButtonComponent,
    TranslatePipe,
    DropdownItemComponent,
    IconComponent,
    RtComponentOutlet,
    NestedTemplateTriggerDirective,
  ],
  templateUrl: './view-settings-more.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewSettingsMoreComponent {
  public mainDropdown = inject(DropdownComponent);
  public dataSourceMoreSettingsCmp = inject(DataSourceMoreSettingsCmp, { optional: true });
  public viewsAnalytics = inject(ViewsAnalytics);
}
